import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@nk/shared';
import { useLocale } from '@/i18n/locale-context';
import { publicApi } from '@/lib/api-client';
import { STALE } from '@/lib/query';
import { ArticleCard } from '@/components/content';
import { EmptyState } from '@/components/ui';
import { CardGridSkeleton, PageHeader, Section } from './page-parts';

/** `/:locale/trending` — PRD §10's ranking as a full page, pins first. */
export default function TrendingPage() {
  const { locale, t } = useLocale();

  const { data, isPending } = useQuery({
    queryKey: queryKeys.trending(locale),
    queryFn: () => publicApi.trending(locale, 20),
    staleTime: STALE.feed,
  });

  return (
    <>
      <PageHeader title={t('section.trending')} />
      <Section>
        {isPending ? (
          <CardGridSkeleton count={8} label={t('status.loading')} />
        ) : (data?.length ?? 0) === 0 ? (
          <EmptyState title={t('empty.noStories')} />
        ) : (
          <div className="grid grid-cols-1 gap-4.5 sm:grid-cols-2 lg:grid-cols-4">
            {/* See `ArticleFeed`: the grid needs an `h2` between the page title and the
                cards, or the heading outline skips a level. */}
            <h2 className="sr-only">{t('section.trending')}</h2>
            {(data ?? []).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        )}
      </Section>
    </>
  );
}
